export const SharedPrefs = {
  APP_LOCALE: 'app/locale',
  PER_PAGE: 'app/per_page',
  APP_THEME: 'app/app_theme',
  TUTORIAL_KEY: 'app/tutorial',
  CURRENT_TEAM: 'app/current_team',
};
